module.exports = __webpack_public_path__ + "static/media/handmade.0ff7db88.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/categories/handmade.svg
 ** module id = 426
 ** module chunks = 0
 **/